import React from 'react';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import MuiGrid from '@mui/material/Grid';
import { format } from 'date-fns';
import { Box, Button, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const QualificationAcceptedDialog = ({
  handleFileChange,
  handleImageClick,
  row,
  onChange,
  fileInputRef,
  changeDialogSize,
  setChangeDialogSize
}) => {
  const handleImageSize = () => {
    setChangeDialogSize((prev) => !prev);
  };

  return (
    <div>
      {changeDialogSize ? (
        <MuiGrid container spacing={3}>
          <MuiGrid item xs={6}>
            <FormGroup>
              <TextField
                margin="normal"
                type="text"
                name="employeeDisplayName"
                label="Employee Name"
                value={row.employeeDisplayName || ''}
                onChange={onChange}
                disabled
              />
              <TextField
                margin="normal"
                name="name"
                label="Qualification Name"
                value={row.name || ''}
                onChange={onChange}
                disabled
              />
              <TextField
                margin="normal"
                type="date"
                name="expiryDate"
                label="Expiry Date"
                value={(row.expiryDate && format(new Date(row.expiryDate), 'yyyy-MM-dd')) || ''}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                margin="normal"
                type="date"
                name="issueDate"
                label="Issue Date"
                value={(row.issueDate && format(new Date(row.issueDate), 'yyyy-MM-dd')) || ''}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                margin="normal"
                type="text"
                name="employeeEmail"
                label="Email"
                value={row.employeeEmail}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
                disabled
              />
              <TextField
                margin="normal"
                name="referenceNumber"
                label="Reference Number"
                value={row.referenceNumber || ''}
                onChange={onChange}
              />
            </FormGroup>
          </MuiGrid>

          <MuiGrid item xs={6}>
            <FormGroup>
              <Box display="flex" flexDirection="column">
                <Typography
                  variant="body2"
                  style={{
                    color: 'rgba(0, 0, 0, 0.6)',
                    fontWeight: '400',
                    textOverflow: 'ellipsis',
                    fontSize: '0.8rem'
                  }}
                >
                  Qualification Image
                </Typography>

                <div style={{ border: '1px solid grey', width: '100%', minHeight: '200px' }}>
                  {row.qualificationUrl ? (
                    (() => {
                      const isPdf =
                        // eslint-disable-next-line no-undef
                        row.qualificationUrl instanceof File
                          ? row.qualificationUrl.type === 'application/pdf'
                          : typeof row.qualificationUrl === 'string' &&
                            row.qualificationUrl.toLowerCase().endsWith('.pdf');

                      const fileUrl =
                        // eslint-disable-next-line no-undef
                        row.qualificationUrl instanceof File
                          ? // eslint-disable-next-line no-undef
                            URL.createObjectURL(row.qualificationUrl)
                          : row.qualificationUrl;

                      if (isPdf) {
                        return (
                          <iframe
                            src={fileUrl}
                            width="100%"
                            height="400px"
                            title="Qualification PDF"
                            style={{ border: 'none' }}
                          />
                        );
                      }

                      return (
                        <img
                          src={fileUrl || '/placeholder.svg'}
                          width="100%"
                          alt="qualification"
                          onClick={handleImageSize}
                          style={{ cursor: 'pointer', objectFit: 'contain' }}
                        />
                      );
                    })()
                  ) : (
                    <img src="/placeholder.svg" width="100%" alt="placeholder" style={{ objectFit: 'contain' }} />
                  )}
                </div>

                <Box display="flex" justifyContent="center" style={{ marginTop: '1rem' }}>
                  <Button variant="contained" onClick={handleImageClick}>
                    <input
                      className="custom-button"
                      ref={fileInputRef}
                      type="file"
                      accept="image/*,.heic,.heif,.pdf"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                    Change File
                  </Button>
                </Box>
              </Box>
            </FormGroup>
          </MuiGrid>
        </MuiGrid>
      ) : (
        <MuiGrid container spacing={3}>
          <MuiGrid item xs={6}>
            <FormGroup>
              <TextField
                margin="normal"
                type="text"
                name="employeeDisplayName"
                label="Employee Name"
                value={row.employeeDisplayName || ''}
                onChange={onChange}
                disabled
              />
              <TextField
                margin="normal"
                name="name"
                label="Qualification Name"
                value={row.name || ''}
                onChange={onChange}
                disabled
              />
              <TextField
                margin="normal"
                type="date"
                name="expiryDate"
                label="Expiry Date"
                value={(row.expiryDate && format(new Date(row.expiryDate), 'yyyy-MM-dd')) || ''}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                margin="normal"
                type="date"
                name="issueDate"
                label="Issue Date"
                value={(row.issueDate && format(new Date(row.issueDate), 'yyyy-MM-dd')) || ''}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
              />
            </FormGroup>
          </MuiGrid>

          <MuiGrid item xs={6}>
            <FormGroup>
              <TextField
                margin="normal"
                type="text"
                name="employeeEmail"
                label="Email"
                value={row.employeeEmail}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
                disabled
              />
              <TextField
                margin="normal"
                name="referenceNumber"
                label="Reference Number"
                value={row.referenceNumber || ''}
                onChange={onChange}
              />

              <Box display="flex" flexDirection="column">
                <Typography
                  variant="body2"
                  style={{
                    color: 'rgba(0, 0, 0, 0.6)',
                    fontWeight: '400',
                    textOverflow: 'ellipsis',
                    fontSize: '0.8rem'
                  }}
                >
                  Qualification Image
                </Typography>

                <div style={{ border: '1px solid grey', width: '100%', minHeight: '200px' }}>
                  {row.qualificationUrl ? (
                    (() => {
                      const isPdf =
                        // eslint-disable-next-line no-undef
                        row.qualificationUrl instanceof File
                          ? row.qualificationUrl.type === 'application/pdf'
                          : typeof row.qualificationUrl === 'string' &&
                            row.qualificationUrl.toLowerCase().endsWith('.pdf');

                      const fileUrl =
                        // eslint-disable-next-line no-undef
                        row.qualificationUrl instanceof File
                          ? // eslint-disable-next-line no-undef
                            URL.createObjectURL(row.qualificationUrl)
                          : row.qualificationUrl;

                      if (isPdf) {
                        return (
                          <iframe
                            src={fileUrl}
                            width="100%"
                            height="400px"
                            title="Qualification PDF"
                            style={{ border: 'none' }}
                          />
                        );
                      }

                      return (
                        <img
                          src={fileUrl || '/placeholder.svg'}
                          width="100%"
                          alt="qualification"
                          onClick={handleImageSize}
                          style={{ cursor: 'pointer', objectFit: 'contain' }}
                        />
                      );
                    })()
                  ) : (
                    <img src="/placeholder.svg" width="100%" alt="placeholder" style={{ objectFit: 'contain' }} />
                  )}
                </div>
                <Box display="flex" justifyContent="center" style={{ marginTop: '1rem' }}>
                  <Button variant="contained" onClick={handleImageClick}>
                    <input
                      className="custom-button"
                      ref={fileInputRef}
                      type="file"
                      accept="image/*,.heic,.heif,.pdf"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                    Change File
                  </Button>
                </Box>
              </Box>
            </FormGroup>
          </MuiGrid>
        </MuiGrid>
      )}
    </div>
  );
};

export default QualificationAcceptedDialog;

QualificationAcceptedDialog.propTypes = {
  handleFileChange: PropTypes.func,
  handleImageClick: PropTypes.func,
  row: PropTypes.any,
  onChange: PropTypes.func,
  fileInputRef: PropTypes.any,
  changeDialogSize: PropTypes.bool,
  setChangeDialogSize: PropTypes.func
};
